var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "widthFull somatoline h-100",
      staticStyle: { "min-height": "85vh" },
      attrs: { id: "firstElem" }
    },
    [
      _c("div", { staticClass: "track" }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticClass:
                "Bold uppercase uppercase center theme widthFull mt-5"
            },
            [_vm._v("\n        La piattaforma sará attiva tra:\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-7 pb-2 mb-5 pt-5 center custForm" },
            [
              _c("countdown", {
                attrs: { time: _vm.countdown },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "row center justify-content-center pb-5 pt-1"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "timeElement Medium uppercaseFont"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(props.days) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.days == 1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  giorno\n                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  giorni\n                "
                                        )
                                      ]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "timeElement Medium uppercaseFont"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(props.hours) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.hours == 1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  ora\n                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  ore\n                "
                                        )
                                      ]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "timeElement Medium uppercaseFont"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(props.minutes) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.minutes == 1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  minuto\n                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  minuti\n                "
                                        )
                                      ]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "timeElement Medium uppercaseFont"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(props.seconds) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.seconds == 1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  secondo\n                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticClass:
                                          "classic Medium uppercase mt-2 mb-0 theme"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  secondi\n                "
                                        )
                                      ]
                                    )
                              ]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid pt-5 pb-5" }, [
      _c("div", { staticClass: "row pt-5 pb-3 center" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-375d5ff6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-375d5ff6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/not_active/index.vue
// module id = null
// module chunks = 